<div class="astral-sidebar-shell">
  <div class="astral-sidebar-content protected-identity-sidebar__scroll-area">
    @if (!isLoading && canActivate) {
      <section class="protected-identity-sidebar__status protected-identity-sidebar__status--inactive">
        <p>{{ 'PROTECTED_IDENTITY.ACTIVATION_INFORMATION' | translate }}</p>
        <strong class="protected-identity-sidebar__timer">
          <i class="fa-solid fa-clock" aria-hidden="true"></i>
          {{ formattedTime }}
        </strong>
        <astral-button
          type="button"
          variant="secondary"
          size="small"
          labelKey="PROTECTED_IDENTITY.EXTEND_ACCESS"
          [disabled]="isLoading || isExtendingAccess"
          (click)="extendAccess()"
        ></astral-button>
      </section>
    }

    @if (!isLoading && !canActivate) {
      <section class="protected-identity-sidebar__status protected-identity-sidebar__status--active" role="status">
        <i class="fa-light fa-triangle-exclamation protected-identity-sidebar__status-icon" aria-hidden="true"></i>
        <p>{{ 'PROTECTED_IDENTITY.SESSION_INFORMATION' | translate }}</p>
        <strong class="protected-identity-sidebar__timer">
          <i class="fa-solid fa-clock" aria-hidden="true"></i>
          {{ formattedTime }}
        </strong>
        <astral-button
          type="button"
          variant="secondary"
          size="small"
          labelKey="PROTECTED_IDENTITY.EXTEND_ACCESS"
          [disabled]="isLoading || isExtendingAccess"
          (click)="extendAccess()"
        ></astral-button>
      </section>
    }

    <div class="protected-identity-sidebar__body astral-stack-l">
      <astral-tabs
        [tabs]="tabs"
        [selectedId]="selectedTabId"
        (selectedIdChange)="onTabChange($event)"
        ariaLabel="PROTECTED_IDENTITY.MENU_ITEM"
        panelId="protected-identity-tab-panel"
        tabIdPrefix="protected-identity-tab"
      ></astral-tabs>

      <section id="protected-identity-tab-panel" class="astral-section-surface">
        @if (selectedTabId === 'personal-data' && form) {
          <form [formGroup]="form" class="astral-stack-m" (ngSubmit)="canActivate ? activate() : save()">
            <astral-input [control]="form.controls['name']"></astral-input>
            <astral-input [control]="form.controls['civicNumber']"></astral-input>
          </form>
        }

        @if (selectedTabId === 'event-log' && logsLoaded) {
          <app-paged-list-view
            class="protected-identity-sidebar__log-list"
            [columnDefinition]="logColumns"
            [itemsSource]="logs"
            [totalCount]="logTotalCount"
            [preferencesKey]="'rent.protected-identity.event-log'"
            (onPageChange)="onLogPageChange($event)"
            (onSortChange)="onLogSortChange($event)"
          ></app-paged-list-view>
        }
      </section>
    </div>
  </div>

  <footer class="astral-sidebar-footer">
    @if (!isLoading && selectedTabId === 'personal-data' && canActivate) {
      <astral-button
        variant="primary"
        type="button"
        labelKey="PROTECTED_IDENTITY.ACTIVATE"
        [disabled]="!form || form.invalid || isLoading"
        (click)="activate()"
      ></astral-button>
    }
    @if (!isLoading && selectedTabId === 'personal-data' && !canActivate) {
      <astral-button
        variant="primary"
        type="button"
        labelKey="SAVE_BTN"
        [disabled]="!form || form.invalid || isLoading"
        (click)="save()"
      ></astral-button>
      <astral-button
        class="protected-identity-sidebar__danger-action"
        variant="secondary"
        type="button"
        labelKey="PROTECTED_IDENTITY.DEACTIVATE"
        [disabled]="isLoading || isConfirmingDeactivation"
        (click)="deactivate()"
      ></astral-button>
    }
    <astral-button variant="secondary" type="button" labelKey="CLOSE_BTN" (click)="close.emit()"></astral-button>
  </footer>
</div>
